<template>
  <TagLink
    :attr-tag="tagLink.attrTag"
    :tag="tagLink.tag"
    class="
      flex
      items-center
      text-gray-medium
      hover:text-blue-primary
      transition-colors
    "
  >
    <AppIcon
      :name="icon.name"
      :size="icon.size"
      :viewBox="icon.viewBox"
    />
    <span class="text__sub--1 mr-2 whitespace-nowrap">
      {{ text }}
    </span>
    <span
      v-if="auth.user.wallet.user.total_credit"
      class="text-blue-primary text__sub--1 mr-3 whitespace-nowrap"
    >
      {{ auth.user.wallet.user.total_credit | currency }}
      <span class="text__sub--4 whitespace-nowrap">
        {{ $t("currency") }}
      </span>
    </span>
    <span
      v-if="!auth.user.wallet.user.total_credit"
      class="text-blue-primary text__sub--3 mr-3 whitespace-nowrap"
    >
      {{ $t("charge_wallet") }}
    </span>
  </TagLink>
</template>

<script>
import convertDigit from '@filters/convert-digit.js'

export default {
  name: 'AvatarUserWallet',
  mixins: [convertDigit],
  inject: ['allProps'],
  props: {
    text: {
      type: String,
      default: ''
    },
    tagLink: {
      type: Object,
      default: () => ({})
    },
    icon: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    auth () {
      return this.allProps.data.auth
    }
  }
}
</script>
